import React, { useRef, useEffect, useState } from "react";
import "./map.css";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "mapbox-gl-geocoder";
import "mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";
import axios from "axios";
import papyros from "./img/papyrus.png";
import ReactDOM from "react-dom/client";

mapboxgl.accessToken =
  "pk.eyJ1IjoidGVnbzcyIiwiYSI6ImNsbmExb242ZTBjbGsyanBvOTRidnlqbmIifQ.EZ7c5jcj0Y-pkLiPO8oBVA";

let mapMovingTimer = null; //store the timer
const host = process.env.REACT_APP_HOST;
const Map = ({
  tableData,
  updateTableData,
  isMapSwitchOn,
  setSelectedRow,
  clickedKeywords,
  selectedRow,
  bounds,
}) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const source = useRef(null);
  const [geoJSON, setGeoJSON] = useState(null);
  // everytime the bounding box changes we update the bound object. This object will be used to store the geographic bounds of the features in the bounds array.
  useEffect(() => {
    if (bounds) {
      console.log(bounds);
      if (map.current) {
        let bound = new mapboxgl.LngLatBounds();
        bounds.forEach((feature) => {
          if (
            feature.features[0].geometry &&
            feature.features[0].geometry.coordinates
          ) {
            let coords = feature.features[0].geometry.coordinates;
            bound.extend(coords);
          } else {
            console.log("here1");
          }
        });
        if (!bound.isEmpty()) {
          console.log(bound);
          map.current.fitBounds(bound, { padding: 100 });
        } else {
          console.log("here2");
        }
      }
    }
  }, [bounds]);

  //Everytime the selected row is updates aka the user clicks on something on the table we get its coordinates and fly to it
  useEffect(() => {
    if (selectedRow) {
      if (selectedRow[0].features[0].geometry) {
        const coordinates = selectedRow[0].features[0].geometry.coordinates;
        console.log(selectedRow.features);

        if (map.current && coordinates) {
          map.current.flyTo({
            center: coordinates,
            zoom: 15,
            padding: { right: 200 },
          });
        }
      }
    }
  }, [selectedRow]);
  //use effect that has everything the map does when the map search is on. Refreshes Points, checks if the map is moving, posts paper based on bounds etc
  useEffect(() => {
    /**
     * This function checks if the map switch is on and if true:
     * Sets a timer to fetch the bounds after 200 milliseconds (0.2 seconds).
     * Axios posts the coordinate bounding box and the keywords selected if there are any.
     * Updates the table data based on the response from the backend
     */

    const refreshPoints = () => {
      if (map.current != null) {
        if (isMapSwitchOn && clickedKeywords) {
          // Clear any previous timer
          if (mapMovingTimer) {
            clearTimeout(mapMovingTimer);
          }

          // Set a new timer to fetch the bounds after 200 milliseconds (0.2 seconds)
          mapMovingTimer = setTimeout(() => {
            const bounds = map.current.getBounds();

            // Get the coordinates of the corners
            const topLeft = bounds.getNorthWest();
            const topRight = bounds.getNorthEast();
            const bottomLeft = bounds.getSouthWest();
            const bottomRight = bounds.getSouthEast();

            // Print the coordinates to the console
            // console.log(topLeft);
            // console.log(topRight);
            // console.log(bottomLeft);
            // console.log(bottomRight);

            const newGeoJSON = createGeoJSONPolygon(
              topLeft,
              topRight,
              bottomLeft,
              bottomRight
            );

            setGeoJSON(newGeoJSON);

            console.log(newGeoJSON);

            axios
              .post(`${host}/paper`, {
                geojson: newGeoJSON,
                keywords: clickedKeywords,
              })
              .then((response) => {
                updateTableData(response.data);
              });

            // Reset the timer
            mapMovingTimer = null;
          }, 1000); //delay time
        } else if (isMapSwitchOn) {
          // Clear any previous timer
          if (mapMovingTimer) {
            clearTimeout(mapMovingTimer);
          }

          // Set a new timer to fetch the bounds after 200 milliseconds (0.2 seconds)
          mapMovingTimer = setTimeout(() => {
            const bounds = map.current.getBounds();

            // Get the coordinates of the corners
            const topLeft = bounds.getNorthWest();
            const topRight = bounds.getNorthEast();
            const bottomLeft = bounds.getSouthWest();
            const bottomRight = bounds.getSouthEast();

            // Print the coordinates to the console
            // console.log(topLeft);
            // console.log(topRight);
            // console.log(bottomLeft);
            // console.log(bottomRight);

            const newGeoJSON = createGeoJSONPolygon(
              topLeft,
              topRight,
              bottomLeft,
              bottomRight
            );

            setGeoJSON(newGeoJSON);

            console.log(newGeoJSON);

            axios
              .post(`${host}/paper`, { geojson: newGeoJSON })
              .then((response) => {
                updateTableData(response.data);
              });

            // Reset the timer
            mapMovingTimer = null;
          }, 1000); //delay time
        }
      }
    };

    // Reference to the event handler
    if (map.current != null) {
      console.log(isMapSwitchOn);
      if (isMapSwitchOn) {
        map.current.on("moveend", refreshPoints);
      }
    }
    return () => {
      if (map.current != null) {
        map.current.off("moveend", refreshPoints);
      }
    };
  }, [isMapSwitchOn]);
  /**
   * This function creates the appropriate structure for the backend to receive the data
   * @param {number} topLeft
   * @param {number} topRight
   * @param {number} bottomLeft
   * @param {number} bottomRight
   * @returns
   */
  function createGeoJSONPolygon(topLeft, topRight, bottomLeft, bottomRight) {
    const coordinates = [
      [
        [topLeft.lng, topLeft.lat],
        [topRight.lng, topRight.lat],
        [bottomRight.lng, bottomRight.lat],
        [bottomLeft.lng, bottomLeft.lat],
        [topLeft.lng, topLeft.lat],
      ],
    ];

    return {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          properties: {},
          geometry: {
            type: "Polygon",
            coordinates: coordinates,
          },
        },
      ],
    };
  }
  /**
   * This function dates the data of the table and uses its coordinates to create the mapboxGL clusters
   * @param {*} data
   *
   */
  const updateMapClusters = (data) => {
    //console.log(source.current)
    if (!map.current || source.current) return;

    //console.log("flag")
    const sourceId = "coordinates1";
    // Remove all existing layers
    const existingLayers = map.current.getStyle().layers;
    existingLayers.forEach((layer) => {
      if (layer.id.startsWith("cluster") || layer.id === "unclustered-point") {
        map.current.removeLayer(layer.id);
      }
      map.current.removeLayer("unclustered-points");
    });
    // Remove the existing source if it exists
    if (map.current.getSource(sourceId)) {
      map.current.removeSource(sourceId);
      map.current.removeImage(papyros);
    }

    const featureCollections = data;

    // Extract individual features from each FeatureCollection and merge them into a single array
    const features = featureCollections.reduce((acc, featureCollection) => {
      return acc.concat(featureCollection.features);
    }, []);
    // Create a GeoJSON source for the data
    map.current.addSource("coordinates1", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: features,
      },
      cluster: true, // Enable clustering
      clusterMaxZoom: 14, // Max zoom level for clustering
      clusterRadius: 60, // Radius for clustering
    });

    // Add a cluster layer to the map
    map.current.addLayer({
      id: "clusters",
      type: "circle",
      source: "coordinates1",
      filter: ["has", "point_count"], // Filter to show clusters only at certain zoom levels
      paint: {
        "circle-color": [
          "step",
          ["get", "point_count"],
          "#99c977",
          10,
          "#628d43",
          50,
          "#3b5727",
        ],
        "circle-radius": ["step", ["get", "point_count"], 5, 3, 20, 40, 30],
      },
    });

    // Add a count layer to show the number of points in each cluster
    map.current.addLayer({
      id: "cluster-count",
      type: "symbol",
      source: "coordinates1",
      filter: ["has", "point_count"],
      layout: {
        "text-field": "{point_count_abbreviated}",
        "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
        "text-size": 12,
      },
      paint: {
        "text-color": "#fff",
      },
    });

    // Add individual coordinates as points
    map.current.addLayer({
      id: "unclustered-point",
      type: "circle",
      source: "coordinates1",
      filter: ["!", ["has", "point_count"]], // Show individual points, not clustered
      paint: {
        "circle-color": "#b2db94", // Customize the circle color as needed
        "circle-radius": 6,
      },
    });

    // inspect a cluster on click
    map.current.on("click", "clusters", (e) => {
      const features = map.current.queryRenderedFeatures(e.point, {
        layers: ["clusters"],
      });
      const clusterId = features[0].properties.cluster_id;
      map.current
        .getSource("coordinates1")
        .getClusterExpansionZoom(clusterId, (err, zoom) => {
          if (err) return;

          map.current.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom,
          });
        });
    });

    map.current.on("mouseenter", "clusters", () => {
      map.current.getCanvas().style.cursor = "pointer";
    });
    map.current.on("mouseleave", "clusters", () => {
      map.current.getCanvas().style.cursor = "";
    });

    let popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
    });

    map.current.on("mouseenter", "unclustered-point", (e) => {
      map.current.getCanvas().style.cursor = "pointer";

      const properties = e.features[0].properties;

      /**Function to process the properties so that re replace the " and [] */
      const processProperties = (properties) => {
        const processedProperties = {};
        for (const key in properties) {
          if (properties.hasOwnProperty(key)) {
            const value = properties[key];
            if (typeof value === "string") {
              processedProperties[key] = value.replace(/[\[\]"]/g, "");
            } else if (Array.isArray(value)) {
              processedProperties[key] = value
                .map((item) => item.replace(/"/g, ""))
                .join(", ");
            } else {
              processedProperties[key] = value;
            }
          }
        }
        return processedProperties;
      };

      // Process the properties
      const processedProperties = processProperties(properties);

      const popupNode = document.createElement("div"); // Create a DOM element directly
      const root = ReactDOM.createRoot(popupNode);
      console.log(processedProperties);

      root.render(
        <ul className="popup-list">
          <li>
            <b>Country:</b> {processedProperties.country}
          </li>
          <li>
            <b>Pilot Area:</b> {processedProperties.pilotArea}
          </li>
          <li>
            <b>Type of Monument:</b> {processedProperties.typeOfMonument}
          </li>
          <li>
            <b>Type of Risk:</b> {processedProperties.typeOfRisk}
          </li>
        </ul>
      );
      popup.setLngLat(e.lngLat).addTo(map.current).setDOMContent(popupNode); // Set the DOM element, not the function
    });

    // map.current.on("mouseleave", "unclustered-point", () => {
    //   map.current.getCanvas().style.cursor = "";
    //   popup.remove();
    // });

    map.current.loadImage(papyros, (error, papyros) => {
      if (error) throw error;
      map.current.addImage("papyros", papyros);
      map.current.addLayer({
        id: "unclustered-points",
        type: "symbol",
        source: "coordinates1",
        filter: ["!has", "point_count"],
        layout: {
          "icon-image": "papyros", // reference the image
          "icon-size": 0.12,
        },
      });
    });

    // map.current.on('click', 'unclustered-point', (e) => {
    //   console.log(e);
    //   onRowClick(e);
    //   });
  };
  //Main use effect to render the map, create tooltips, add clusters etc
  useEffect(() => {
    if (map != null && map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: `mapbox://styles/tego72/clo6y559n00si01qmhq4m8500`,
      center: [23.77262921129215, 38.07445185628109],
      zoom: 3.5,
    });

    // Fetch GeoJSON data from the backend
    axios
      .get(`${host}/geojsons`)
      //axios.get('/paper/0')
      .then((response) => {
        const featureCollections = response.data;

        // Extract individual features from each FeatureCollection and merge them into a single array
        const features = featureCollections.reduce((acc, featureCollection) => {
          return acc.concat(featureCollection.features);
        }, []);
        // Create a GeoJSON source for the data
        console.log(features);
        map.current.addSource("coordinates", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: features,
          },
          cluster: true, // Enable clustering
          clusterMaxZoom: 14, // Max zoom level for clustering
          clusterRadius: 60, // Radius for clustering
        });

        // Add a cluster layer to the map
        map.current.addLayer({
          id: "clusters",
          type: "circle",
          source: "coordinates",
          filter: ["has", "point_count"], // Filter to show clusters only at certain zoom levels
          paint: {
            "circle-color": [
              "step",
              ["get", "point_count"],
              "#99c977",
              10,
              "#628d43",
              50,
              "#3b5727",
            ],
            "circle-radius": [
              "step",
              ["get", "point_count"],
              20,
              10,
              30,
              50,
              40,
            ],
          },
        });

        // Add a count layer to show the number of points in each cluster
        map.current.addLayer({
          id: "cluster-count",
          type: "symbol",
          source: "coordinates",
          filter: ["has", "point_count"],
          layout: {
            "text-field": "{point_count_abbreviated}",
            "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
            "text-size": 12,
          },
          paint: {
            "text-color": "#fff",
          },
        });

        // Add individual coordinates as points
        map.current.addLayer({
          id: "unclustered-point",
          type: "circle",
          source: "coordinates",
          filter: ["!", ["has", "point_count"]], // Show individual points, not clustered
          paint: {
            "circle-color": "#b2db94", // Customize the circle color as needed
            "circle-radius": 8,
          },
        });
        map.current.addControl(
          new MapboxGeocoder({
            accessToken: mapboxgl.accessToken,
            marker: false,
            mapboxgl: mapboxgl,
            placeholder: "Search",
          })
        );

        // Add zoom and rotation controls to the map.
        map.current.addControl(new mapboxgl.NavigationControl());

        map.current.addControl(
          new mapboxgl.GeolocateControl({
            positionOptions: {
              enableHighAccuracy: true,
            },
            trackUserLocation: true,
            showUserHeading: true,
          })
        );

        // inspect a cluster on click
        map.current.on("click", "clusters", (e) => {
          const features = map.current.queryRenderedFeatures(e.point, {
            layers: ["clusters"],
          });
          const clusterId = features[0].properties.cluster_id;
          map.current
            .getSource("coordinates")
            .getClusterExpansionZoom(clusterId, (err, zoom) => {
              if (err) return;

              map.current.easeTo({
                center: features[0].geometry.coordinates,
                zoom: zoom,
              });
            });
        });
        map.current.on("mouseenter", "clusters", () => {
          map.current.getCanvas().style.cursor = "pointer";
        });
        map.current.on("mouseleave", "clusters", () => {
          map.current.getCanvas().style.cursor = "";
        });
        map.current.on("mouseenter", "unclustered-point", () => {
          map.current.getCanvas().style.cursor = "pointer";
        });
        map.current.on("mouseleave", "unclustered-point", () => {
          map.current.getCanvas().style.cursor = "";
        });
        map.current.loadImage(papyros, (error, papyros) => {
          if (error) throw error;
          map.current.addImage("papyros", papyros);
          map.current.addLayer({
            id: "unclustered-points",
            type: "symbol",
            source: "coordinates",
            filter: ["!has", "point_count"],
            layout: {
              "icon-image": "papyros", // reference the image
              "icon-size": 0.18,
            },
          });
        });

        map.current.on("click", "unclustered-point", (e) => {
          let features = map.current.queryRenderedFeatures(e.point, {
            layers: ["unclustered-point"],
          });

          console.log(features);
          axios
            .post(`${host}/paper`, {
              geojson: {
                type: "FeatureCollection",
                features: [
                  {
                    type: "Feature",
                    properties: {},
                    geometry: {
                      coordinates: [
                        [
                          [
                            features[0].geometry.coordinates[0] - 0.01,
                            features[0].geometry.coordinates[1] + 0.01,
                          ],
                          [
                            features[0].geometry.coordinates[0] + 0.01,
                            features[0].geometry.coordinates[1] + 0.01,
                          ],
                          [
                            features[0].geometry.coordinates[0] + 0.01,
                            features[0].geometry.coordinates[1] - 0.01,
                          ],
                          [
                            features[0].geometry.coordinates[0] - 0.01,
                            features[0].geometry.coordinates[1] - 0.01,
                          ],
                          [
                            features[0].geometry.coordinates[0] - 0.01,
                            features[0].geometry.coordinates[1] + 0.01,
                          ],
                        ],
                      ],
                      type: "Polygon",
                    },
                  },
                ],
              },
            })
            .then(
              (response) => {
                console.log(response.data);
                setSelectedRow(response.data);
              }

              //   let features = map.current.queryRenderedFeatures(e.point, {
              //     layers: ['unclustered-point']
              // });
              //   console.log(features);
            );
        });
      })
      .catch((error) => {
        console.error("Error fetching GeoJSON data:", error);
      });

    let popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
    });

    map.current.on("mouseenter", "unclustered-point", (e) => {
      map.current.getCanvas().style.cursor = "pointer";

      const properties = e.features[0].properties;

      // Define a function to process the properties so that re replace the " and []
      const processProperties = (properties) => {
        const processedProperties = {};
        for (const key in properties) {
          if (properties.hasOwnProperty(key)) {
            const value = properties[key];
            if (typeof value === "string") {
              processedProperties[key] = value.replace(/[\[\]"]/g, "");
            } else if (Array.isArray(value)) {
              processedProperties[key] = value
                .map((item) => item.replace(/"/g, ""))
                .join(", ");
            } else {
              processedProperties[key] = value;
            }
          }
        }
        return processedProperties;
      };

      // Process the properties
      const processedProperties = processProperties(properties);

      const popupNode = document.createElement("div"); // Create a DOM element directly
      const root = ReactDOM.createRoot(popupNode);
      console.log(processedProperties);

      root.render(
        <ul>
          <li>
            <b>Country:</b> {processedProperties.country}
          </li>
          <li>
            <b>Pilot Area:</b> {processedProperties.pilotArea}
          </li>
          <li>
            <b>Type of Monument:</b> {processedProperties.typeOfMonument}
          </li>
          <li>
            <b>Type of Risk:</b> {processedProperties.typeOfRisk}
          </li>
        </ul>
      );
      popup.setLngLat(e.lngLat).addTo(map.current).setDOMContent(popupNode); // Set the DOM element, not the function
    });

    map.current.on("mouseleave", "unclustered-point", () => {
      map.current.getCanvas().style.cursor = "";
      popup.remove();
    });

    // new mapboxgl.Marker()
    //   .setLngLat([23.661433424922038, 37.938586037449085])
    //   .addTo(map.current);
  }, []);

  // every time table data changes, update map
  useEffect(() => {
    //console.log(tableData , tableData.length>0 , map.current , map.current.isStyleLoaded())
    if (
      tableData &&
      tableData.length > 0 &&
      map.current &&
      map.current.isStyleLoaded()
    ) {
      // Filter tableData to contain unique items based on the 'id' property
      // let idList=tableData.map(item=>(item.features[0].properties.id))
      // let uniqueIds=Array.from(new Set(idList))
      // console.log(uniqueIds)
      const uniqueTableData = tableData.filter((item, index, self) => {
        //console.log(item);
        const firstIndex = self.findIndex((el) => {
          const coordinates1 = el.features[0].geometry?.coordinates;
          const coordinates2 = item.features[0].geometry?.coordinates;

          if (coordinates1 && coordinates2) {
            return (
              coordinates1[0] === coordinates2[0] &&
              coordinates1[1] === coordinates2[1]
            );
          }
          return false;
        });
        return index === firstIndex;
      });
      console.log(tableData);

      updateMapClusters(uniqueTableData);
      //updateMapClusters(tableData);
    }
  }, [tableData]);

  return (
    <>
      <div ref={mapContainer} className="map-container" />
      {/* <div className="custom-marker"></div> */}
    </>
  );
};
export { Map };
